import React from 'react';
import './StepOne.css'; // Import the CSS file for styling

const formatTime = (dateTime) => {
    const date = new Date(dateTime);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const formatDate = (dateTime) => {
    const date = new Date(dateTime);
    return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
};

const StepOne = ({ training, formData, handleChange, errors, handleNext }) => {
    return (
        <>
            <h2 className="step-one-title">Register for {training.summary}</h2>
            <p className="step-one-paragraph shine-effect">{formatDate(training.start.dateTime)}</p>
            <p className="step-one-paragraph shine-effect">{`${formatTime(training.start.dateTime)} - ${formatTime(training.end.dateTime)}`}</p>
            <label htmlFor="name">Name</label>
            <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
            />
            {errors.name && <p className="error">{errors.name}</p>}

            <label htmlFor="lastname">Last Name</label>
            <input
                type="text"
                id="lastname"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
                placeholder="Enter your last name"
                required
            />
            {errors.lastname && <p className="error">{errors.lastname}</p>}

            <label htmlFor="email">Email Address</label>
            <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
            />
            {errors.email && <p className="error">{errors.email}</p>}

            <label htmlFor="phone">Phone Number</label>
            <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                required
            />
            {errors.phone && <p className="error">{errors.phone}</p>}

            <button className="form-button" onClick={handleNext}>Next</button>
        </>
    );
};

export default StepOne;
